<template>
    <div>
        <ApplicationOverlay />
        <div v-show="hasSearched">
            <div class="columns">
                <div class="filters">
                    <hp5-skip-links main-link-text="Skip to search results" v-on:hp5SkipLinkClick="moveFocus()" />
                    <BenefitsContainer />
                    <FilterContainer />
                </div>
                <div class="results">
                    <ResultsContainer />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const { hasSearched } = useFCPModel()
    
    const moveFocus = () => {    
        document.getElementById("results").focus();
    }

</script>

<style scoped lang="scss">
   @use '../../assets/scss/breakpoints' as *;
    .columns {
        display: block;

        @include small-up {
            display: grid;
            grid-template-columns: 26% 74%;
            column-gap: var(--spacing-md);
        }
    }

    hp5-skip-links {
        border-bottom: 0;
    }

    @include xsmall {
        hp5-skip-links {
            display: block;
        }
    }

</style>